import { EmptyUUID } from '@cbgms/base/utils/uuid'

export const requiredUUID = (value?: string) => {
  return value === '' || value === null || value === undefined || value === EmptyUUID ? 'global.field_is_required' : undefined
}
